export default "__VITE_ASSET__0c0f1d10__"